<template>
  <div>
    <legend>Información general</legend>

    <div class="col-12 alert alert-info mb-0">Los datos personales (curp, correo personal, números telefónicos, estado civil, domicilio, observaciones) recabados serán protegidos.</div>

    <div class="row">
      <div class="col-md-4 form-group">
          <label class="control-label">
            Nombre(s)
          </label>
          <input class="form-control"
                 type="text"
                 name="nombres"
                 v-validate="'required'"
                 v-model="model.nombres"
                 placeholder="Nombre(s)"
          />

        <small class="text-danger">{{ errors.first('nombres')}}</small>

      </div>
      <div class="col-md-4 form-group">
          <label class="control-label">
           Primer Apellido
          </label>
          <input class="form-control"
                 type="text"
                 name="primer_apellido"
                 v-validate="'required'"
                 v-model="model.primer_apellido"
                 placeholder="Primer Apellido "
          />
          <small class="text-danger" >
            {{ getError('primer_apellido') }}
          </small>
      </div>
      <div class="col-md-4 form-group">
          <label class="control-label">
           Segundo Apellido
          </label>
          <input class="form-control"
                 type="text"
                 name="segundo_apellido"
                 v-model="model.segundo_apellido"
                 placeholder="Segundo Apellido"
          />
      </div>
 <div class="col-md-4 form-group">
          <label class="control-label">
            CURP
          </label>
          <input class="form-control"
                 type="text"
                 name="curp"
                 v-validate="'required|uppercase|curp'"
                 v-model="model.curp"
                 placeholder="CURP"
                 disabled
          />
            <small class="text-danger">{{ errors.first('curp')}}</small>
      </div>
      <div class="col-md-4 form-group">
          <label class="control-label">
            RFC con homoclave:
          </label>
          <input class="form-control"
                 type="text"
                 name="rfc"
                 v-validate="'required|uppercase|max:13|rfc'"
                 v-model="model.rfc"
                 placeholder="RFC"
                 disabled style="width:250px"
          />
            <small class="text-danger">{{ errors.first('rfc')}}</small>

      </div>
      <!--                 v-model="model.rfc.substr(0,10)"-->
      <!--<div class="col-md-4 form-group">

          <label class="control-label">
            Homoclave:
          </label>
          <input class="form-control"
                 type="text"
                 name="Homoclave"
                 v-validate="'required'"
                 v-model="model.rfc"

                 placeholder="Homoclave"
                 disabled style="width:100px"
          />
          </div>
          -->
          <!--                 v-model="model.rfc.substr(-3)"
-->



      <div class="col-md-4 form-group">
          <label class="control-label">
            Correo electrónico institucional
          </label>
          <input class="form-control"
                 type="text"
                 name="correo_electronico_laboral"
                 v-validate="'required'"
                 v-model="model.correo_electronico_laboral"
                 placeholder="Correo Laboral"
          />
          <small class="text-danger" >
            {{ getError('correo_electronico_laboral') }}
          </small>
      </div>
      <div class="col-md-4 form-group">
          <label class="control-label">
            Correo electrónico personal/alterno
          </label>
          <input class="form-control"
                 type="text"
                 name="correo_electronico_personal"
                 v-validate="'required'"
                 v-model="model.correo_electronico_personal"
                 placeholder="Correo Personal"
          />
          <small class="text-danger" >
            {{ getError('correo_electronico_personal') }}
          </small>
      </div>


      <div class="col-md-4 form-group">
          <label class="control-label">
            Número telefónico de casa
          </label>
          <input class="form-control"
                 type="text"
                 name="telefono_particular"
                 v-validate="'required'"
                 v-model="model.telefono_particular"
                 placeholder="Número telefónico de casa"
          />
          <small class="text-danger" >
            {{ getError('telefono_particular') }}
          </small>
      </div>
      <!--v-if="mostrarCampos"-->
      <div class="col-md-4 form-group" >
          <label class="control-label">
              Teléfono celular personal
          </label>
          <input class="form-control"
                 type="text"
                 name="telefono_celular"
                 v-model="model.telefono_celular"
                 placeholder="Teléfono celular personal"
          />
      </div>
      <div class="col-md-8 form-group" >
        <label class="control-label">
                Estado Civil
            </label>
              <el-select  clearable class="select-default"
                        placeholder="Estado Civil"
                        filterable
                        name="edocivil"
                        v-validate="'required'"
                        v-model="model.estado_civil_id">
              <el-option v-for="option in estadosCi"
                          class="select-default"
                          :value="option.id"
                          :label="option.valor"
                          :key="option.valor">
              </el-option>
            </el-select>

            <small class="text-danger" >
              {{ getError('edocivil') }}
            </small>

      </div>
      <div class="col-md-4 form-group" v-if="model.estado_civil_id == 1">
            <label class="control-label">
              Régimen matrimonial
            </label>
              <el-select  clearable class="select-default"
                        placeholder="Régimen matrimonial"
                        filterable
                        v-model="model.regimen_matrimonial_id">
              <el-option v-for="option in regimenMat"
                          class="select-default"
                          :value="option.id"
                          :label="option.valor"
                          :key="option.valor">
              </el-option>




            </el-select>
        </div>
        <div class="col-md-4 form-group">
          <label class="control-label">
              País de nacimiento
          </label>
            <el-select  clearable class="select-default"
                       placeholder="País"
                       filterable
                       v-validate="'required'"
                       name="pais_nacimiento_id"
                       v-model="model.pais_nacimiento_id">
            <el-option v-for="option in paises"
                        class="select-default"
                        :value="option.id"
                        :label="option.valor"
                        :key="option.valor">
            </el-option>
          </el-select>
          <small class="text-danger" >
            {{ getError('pais_nacimiento_id') }}
          </small>
        </div>
        <div class="col-md-4 form-group">
            <label class="control-label">
              Nacionalidad
            </label>
            <el-select  clearable multiple
                       filterable
                       class="select-default"
                       placeholder="Nacionalidades"
                       v-validate="'required'"
                       name="nac"
                       v-model="model.nac">
            <el-option v-for="option in paises"
                        class="select-default"
                        :value="option.id"
                        :label="option.valor"
                        :key="option.valor">
            </el-option>
          </el-select>
           <small class="text-danger" >
            {{ getError('nac') }}
          </small>
      </div>

    </div>
    <div class="row">
      <!--

      <div class="col-md-4 form-group" >
          <label class="control-label">
              Entidad de nacimiento
          </label>
            <el-select  clearable class="select-default"
                      placeholder="Entidad:"
                      filterable
                      name="entidad_federativa_nacimiento_id"
                      v-validate="'required'"
                      v-model="model.entidad_federativa_nacimiento_id">
            <el-option v-for="option in entidades"
                        class="select-default"
                        :value="option.id"
                        :label="option.nom_ent"
                        :key="option.nom_ent">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="entidad_federativa_nacimiento_id.invalid">
            {{ getError('entidad_federativa_nacimiento_id') }}
          </small>
      </div>
      -->



      <div class="col-md-4 form-group" v-if="mostrarCampos">
            <label class="control-label">
              Fecha de Nacimiento
            </label>
            <div class="form-group">
              <el-date-picker
              name="fecha_nacimiento"
              v-validate="'required'"
              v-model="model.fecha_nacimiento"
              format="dd/MM/yyyy"
              type="date" placeholder="Elige un día">
              </el-date-picker>
            </div>
             <small class="text-danger">
              {{ getError('fecha_nacimiento') }}
            </small>
      </div>
      <div class="col-md-4 form-group" v-if="mostrarCampos">
          <label class="control-label">
            No. Identificación:
          </label>
          <input class="form-control"
                 type="text"
                 name="numero_identificacion_oficial"
                 v-model="model.numero_identificacion_oficial"
                 placeholder="Número de Identificación Oficial"
          />
      </div>




      <div class="col-md-12 form-group">
          <label class="control-label">
Aclaraciones y observaciones          </label>
          <textarea class="form-control"
                 type="text"
                 name="aclaraciones"
                 v-model="model.aclaraciones"
                 placeholder="Aclaraciones y observaciones"
          />

      </div>
    </div>
    <br>
    <domicilio v-model="n_domicilio" ref="Domicilio"></domicilio>

    <div class="row">

    </div>


  </div>
</template>
<script>
 import {Tag, Select, DatePicker} from 'element-ui'


  import Domicilio from '../Domicilio.vue'

  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      Domicilio
    },inject: ['$validator'],
    computed: {
    /*  ...mapFields(['nombres','primer_apellido','nac','pais_nacimiento_id','entidad_federativa_nacimiento_id','rfc',
                    'curp','fecha_nacimiento','correo_electronico_personal','correo_electronico_laboral','edocivil','telefono_particular'])
      */
    },
    data () {
      return {
        mostrarCampos: false,
        validaciones:{
          curp: false,
          rfc: false
        },
        datePicker: '',
        ip_id: null,
        regexp:{
          mail:''
        },
        paisesnac:{},
        nacionalidadArr:[150],
        estadosCi:{},
        regimenMat:{},
        n_domicilio: {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        },
        model: { pais_nacimiento_id:150 },


      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },

      getEstadosC(){
        this.$http.get('edocivil').then(
            response => {
                this.estadosCi = response.data.estadoCivil;
            },
            error =>{
                this.StepError(error);
                console.log(error);
            }
        )
      },
       getRegimenMat(){
        this.$http.get('regmatrimonial').then(
            response => {
                this.regimenMat = response.data.regimen;
            },
            error =>{
                this.StepError(error);
                console.log(error);
            }
        )
      },
      getDatosP(){
        var v = this;
        this.$http.get('infpersonal/'+this.ip_id).then(
            response => {

                this.model = response.data.informacion;
                ///para tomar solo el dato correspondiente a la nacionalidad
                this.model.pais_nacimiento_id = this.model.pais_nacimiento_id ==null ? 150 : this.model.pais_nacimiento_id;

                 if(response.data.informacion.nac.length > 0){
                   var nacionalidadArr =[];
                    $.each(response.data.informacion.nac, function(key, value) {
                      nacionalidadArr.push(value.nac_id);
                    })
                 }

                this.model.nac = nacionalidadArr;

                this.editDomicilio();
                /*this.n_domicilio = {'pais_id' : v.model.domicilio_pais_id,
                                    'entidadF': v.model.domicilio_entidad_federativa_id,
                                    'municipio': v.model.domicilio_municipio_id,
                                    'colonia': v.model.domicilio_colonia,
                                    'cp': v.model.domicilio_cp,
                                    'localidad': v.model.domicilio_localidad_id,
                                    'ext': v.model.domicilio_numext,
                                    'int': v.model.domicilio_numint,
                                    'vialidad': v.model.domicilio_vialidad_tipo,
                                    'vialidad_nombre': v.model.domicilio_vialidad_nombre,
                                    'domicilio_observaciones': v.model.domicilio_observaciones

                                    }*/
            },
            error =>{
                this.StepError(error);
                console.log(error);
            }
        )
      },
      actuali(){
        this.$http.put('infpersonal/'+this.ip_id, this.model).then(
            response => {
                this.model = response.data.informacion;
            },
            error =>{
                this.StepError(error);
                console.log(error);
            }
        )
      },

      getSafe(fn, defaultVal) {
          try {
              return fn();
          } catch (e) {
              return defaultVal;
          }
      },
      valida(){
        return this.$validator.validateAll();
        //this.$validator.validateAll().then(response => {
          //this.$refs.DatosPersonales.validateAll().then(response => {
              return response;
        //})
      },
      editDomicilio() {
              if (this.model) {
                this.n_domicilio = {'pais_id' : this.model.domicilio_pais_id,
                                    'entidadF': this.model.domicilio_entidad_federativa_id,
                                    'municipio': this.model.domicilio_municipio_id,
                                    'colonia': this.model.domicilio_colonia,
                                    'cp': this.model.domicilio_cp,
                                    'localidad': this.model.domicilio_localidad_id,
                                    'ext': this.model.domicilio_numext,
                                    'int': this.model.domicilio_numint,
                                    'vialidad': this.model.domicilio_vialidad_tipo,
                                    'vialidad_nombre': this.model.domicilio_vialidad_nombre,
                                    'domicilio_observaciones': this.model.domicilio_observaciones
                      }
              }
            },
            initDomicilio() {
              this.n_domicilio = {
                pais_id: 150, // México
                entidadF: 11, // Estado Guanajuato
                municipio: '',
                localidad: '',
                cp: '',
                colonia: '',
                vialidad: '',
                vialidad_nombre: '',
                ext: '',
                int: ''
              };
            },
    },
    watch: {
        n_domicilio: {
          handler: function () {
            if (this.n_domicilio) {
              this.model.domicilio_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
              this.model.domicilio_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
              this.model.domicilio_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
              this.model.domicilio_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
              this.model.domicilio_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
              this.model.domicilio_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
              this.model.domicilio_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
              this.model.domicilio_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
              this.model.domicilio_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
              this.model.domicilio_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
              this.model.domicilio_observaciones = this.n_domicilio.domicilio_observaciones ? this.n_domicilio.domicilio_observaciones : "";

            }
          },
          deep: true
        }
      },

    created(){
        this.ip_id = this.getId();
        this.getEstadosC();
        this.getRegimenMat();
    //    this.getPaisesNac();
        this.getDatosP();

    },
    mounted() {
      this.checkCatalogs();
      this.model.pais_nacimiento_id = 150;
      //this.model.paisesnac = this.paises;

    },

  }
</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Personal/DatosPersonales.vue